<template>
	<r-standard-modal-form
		class="filter-columns-modal-outter"
		:style="{
			width: `264px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title">{{ titleText }}</span>
		<div slot="body" class="filter-columns-modal-body">
			<div class="input-header">Your Columns</div>
			<filter-field-toggle
				v-for="(fieldStruct, index) in filteredFields"
				:key="fieldStruct.key"
				:sheetView="sheetView"
				:fieldGUID="fieldStruct.key"
				:override="index === 0"
				:setRelativeColumnLocation="overrideObject && overrideObject.setRelativeColumnLocation ? overrideObject.setRelativeColumnLocation : null"
			>
			</filter-field-toggle>
			<div 
				v-if="workbookHasPermission('field_addNew')"
				class="add-column-container"
				@click="addNewField"
			>
				<r-standard-icon
					class="add-icon"
					icon="dropdownPlus"
				></r-standard-icon>
				<div class="add-label">Create New</div>
			</div>
			<r-button 
				theme="dark-blue" 
				fullWidth 
				class="submit-button" 
				@click="$emit('closeModal')"
			>
				Done
			</r-button>
		</div>
	</r-standard-modal-form>
</template>
<script>

import CommonVueFunctions from 'vue/sheet-views/common/common-vue-functions';

import FilterFieldToggle from 'vue/sheet-views/common/fields/filter-field-toggle';

export default {
	name:'filter-columns-modal',
	$pubsub:{
		newColumnModal:{},
	},
	data(){
		return{
		};
	},
	components:{
		FilterFieldToggle,
	},
	inject:['workbookHasPermission', 'sheetGlobalState'],
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		// Contains setRelativeColumnLocation with an anchorFieldGUID and a direction: 0 for left, 1 for right
		overrideObject: {
			required: false,
			type: Object
		}
	},
	computed:{
		schemaObject(){
			return this.dataStore.meta.schema;
		},
		dataStore(){
			return this.sheetView.sheetViewGroup.dataStore;
		},
		sortedFields(){
			return CommonVueFunctions.computed.sortedFields.apply(this, [true]).slice(0, -1);
		},
		filteredFields(){
			return this.sortedFields.slice(1).filter(function isField(field){
				return field.type === 'field';
			});
		},
		nameFieldGUID(){
			return this.sortedFields[0].guid;
		},
		visibleColumns(){
			const vcSelf = this;
			return vcSelf.sortedFields.filter(function onlyShownFields(fieldStruct){
				if(fieldStruct.guid === vcSelf.nameFieldGUID){
					return true;
				}
				if(vcSelf.sheetView.properties.fields.shownFields){
					return vcSelf.sheetView.properties.fields.shownFields.indexOf(fieldStruct.guid) >= 0;
				}
				return false;
			});
		},
		numberVisibleColumns(){
			return this.visibleColumns.length;
		},
		titleText(){
			if(this.numberVisibleColumns === 1){
				return `${this.numberVisibleColumns} Field Displayed`;
			}
			else{
				return `${this.numberVisibleColumns} Fields Displayed`;
			}
		},
	},
	methods:{
		addNewField(){
			this.$pubsub.modules.newColumnModal.pub('openModal', {
				sheetView: this.sheetView,
				overrideObject: this.overrideObject
			});
		},
	},
}
</script>

<style scoped lang="scss">
	
.filter-columns-modal-outter{
	width: 100%;

	.filter-columns-modal-body{
		width: 100%;
		user-select: none;

		.input-header{
			font-family: $rvFontFamily;
			font-weight: 600;
			font-size: 13px;
			line-height: 19px;
			letter-spacing: 0.01em;
			color: $p-color-grey-400;
			margin-bottom: 6px;
		}

		.add-column-container{
			@include flex(row, flex-start);
			width: 100%;
			height: 36px;
			cursor: pointer;
			margin-bottom: 30px;

			&:hover{
				background: $p-color-grey-100;
			}

			&:active{
				filter: brightness(98%);
			}

			.add-icon{
				margin-left: 6px;
				margin-right: 6px;
			}
			.add-label{
				font-family: $rvFontFamily;
				font-weight: 400;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				color: $p-color-grey-400;
			}
		}
	}
}

</style>
